import PropTypes from "prop-types";

import focusElementRefKeys from "@/view/constants/focusElementRefKeys";
import useFocusManager from "@/view/utils/useFocusManager";
import { titleCss } from "./StudentAssignmentTitle.style";

const propTypes = {
  __cssFor: PropTypes.shape({
    root: PropTypes.object,
  }),
  children: PropTypes.node,
};

const StudentAssignmentTitle = ({ children, __cssFor }) => {
  const { setFocusManagerRef } = useFocusManager();

  return (
    <h2
      css={[titleCss, __cssFor?.root]}
      ref={(ref) =>
        setFocusManagerRef(ref, focusElementRefKeys.assignmentEditorHeading)
      }
      tabIndex={-1}
    >
      {children}
    </h2>
  );
};

StudentAssignmentTitle.propTypes = propTypes;

export default StudentAssignmentTitle;
